import { useState, useEffect } from 'react';
import { OtpTimerState } from '../types';

const useOtpTimer = (initialTime: number = 60): OtpTimerState => {
  const [canResend, setCanResend] = useState<boolean>(true);
  const [resendTimer, setResendTimer] = useState<number>(initialTime);

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined;
    
    if (!canResend && resendTimer > 0) {
      timer = setInterval(() => {
        setResendTimer((prev) => {
          if (prev <= 1) {
            setCanResend(true);
            return initialTime;
          }
          return prev - 1;
        });
      }, 1000);
    }
    
    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [canResend, resendTimer, initialTime]);

  const startTimer = (): void => {
    setCanResend(false);
    setResendTimer(initialTime);
  };

  return { canResend, resendTimer, startTimer };
};

export default useOtpTimer; 